import type { ReactNode } from 'react';

export const symbol_wifi_lock: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M682-120q-17 0-28.5-11.39Q642-142.77 642-159.6v-118.8q0-16.83 11.5-28.21Q665-318 682-318h1v-39q0-33.83 24.12-57.91 24.13-24.09 58-24.09Q799-439 823-414.91q24 24.08 24 57.91v39h1q17 0 28.5 11.39Q888-295.23 888-278.4v118.8q0 16.83-11.5 28.21Q865-120 848-120H682Zm41-198h84v-39q0-19-11.5-30.5T765-399q-19 0-30.5 11.5T723-357v39ZM480-800q120 0 228.5 41T909-644q10.62 8.12 16.31 19.56Q931-613 932-600q1 13-3.81 24.94Q923.37-563.13 913-553l-52 53q-8 8-20.5 8t-20.5-8q-8-8-8-20.5t8-20.5l52-53q-87-68-184.5-107T480-740q-110 0-207.5 39T88-594l392 392 39-39q8-8 20.5-8t20.5 8q8 8 8 20.5t-8 20.5l-38 38q-9 9-20 13t-22 4q-11 0-22-4t-20-13L48-552q-9.75-9.91-14.87-22.49Q28-587.08 29-600.04t6-24.46Q40-636 51-645q92-74 200.5-114.5T480-800Zm0 329Z"
		/>
	</svg>
);
